import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DtoClientForViewVM } from '../../../Model/clients/DtoClientForViewVM';
import { DialogService } from '../../../Shared/Services/dialog.service';

@Component({
  selector: 'app-submit-contract',
  templateUrl: './submit-contract.component.html',
  styleUrl: './submit-contract.component.scss'
})
export class SubmitContractComponent {
  @Input() AllClients: DtoClientForViewVM[] = [];
  @Output() createContract = new EventEmitter<boolean>();
  @Output() selectedClient = new EventEmitter<DtoClientForViewVM>();
  isCreateContract?: boolean = false;

  constructor(private dialogService: DialogService) { }

  ngOnInit() { }

  CreateContract(client?: DtoClientForViewVM) {
    this.dialogService.confirmDialog({
      titleKey: 'confirmation',
      messageKey: 'AreYouSuretoCreateContract',
      confirmTextKey: 'Yes',
      cancelTextKey: 'No'
    }).subscribe(isConfirmed => {
      if (isConfirmed) {
        this.isCreateContract = true;
        this.createContract.emit(this.isCreateContract);
        this.selectedClient.emit(client);
      }
    });
  }
}
